export const sacarPorcentaje = ({valor, maximo}) =>{

    let num = ((valor * 100) / maximo).toFixed(0)

    if (num > 100){
        return 100
    }
    return num

}